import { Injectable } from '@angular/core';

import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class P2ExportProcService {
    constructor(private dataTask: DataTaskService) {}

    /** @datatask 1880 */
    public async getGridExportArguments(params: GridExportArgParams): Promise<GridExportArgGet> {
        return (await this.dataTask.Post(1880, params))[0];
    }

    /** @datatask 3405 */
    public getGridExportPriceLists(): Promise<GridExportPriceListItem[]> {
        return this.dataTask.Post(3405, {});
    }

    /** @datatask 3450 */
    public getGridExportActiveStatuses(): Promise<P2ExportProcListItem[]> {
        return this.dataTask.Post(3450, { add_all: '1' });
    }

    /** @datatask 891 */
    public getExportProcedures(params: { exclude_inactive: number; exclude_grid_export: number }): Promise<P2ExportProcListItem[]> {
        return this.dataTask.Post(891, params);
    }

    /**
     * @datatask 892
     * @datataskName sp_ws_p2_p2exportproc_get
     * @param params Export procedure identifier.
     * @returns Promise containing the export procedure configuration.
     */
    public async getExportProc(params: P2ExportProcParams): Promise<P2ExportProcGet> {
        return ((await this.dataTask.Post(892, params)) as P2ExportProcGet[])[0];
    }

    /**
     * @datatask 1890
     * @datataskName sp_ws_p2_w_p2exportproc_webpage_list
     * @param params Webpage list parameters.
     * @returns Promise containing the available webpages.
     */
    public getWebpagesList(params: P2ExportProcWebpageListParams): Promise<P2ExportProcWebpageItem[]> {
        return this.dataTask.Post(1890, params);
    }

    /**
     * @datatask 893
     * @datataskName sp_ws_p2_p2exportproc_save
     * @param params Export procedure configuration to save.
     * @returns Promise that resolves when the export procedure has been saved.
     */
    public saveExportProc(params: P2ExportProcGet): Promise<void> {
        return this.dataTask.Post(893, params);
    }
}

export interface P2ExportProcParams {
    p2_exportproc_keyno: string | number;
}

export interface P2ExportProcWebpageListParams {}

export interface P2ExportProcGet extends P2ExportProcParams {
    p2_datatask_keyno?: string | number;
    p2_exportproc_name: string;
    grid_count: string | number;
    proc_name: string;
    proc_name_2: string;
    proc_name_3: string;
    p2_importproc_keyno: string | number;
    edi_destination_keyno: string | number;
    edi_type_keyno: string | number;
    autocreate: '0' | '1';
    table_name: string;
    isactive: '0' | '1';
    gridexport: '0' | '1';
    show_table_name_export: '0' | '1';
    autoretrieve: '0' | '1';
    csvexport: '0' | '1';
    tailoraccess_keyno: string | number;
    h_selection_criteria: string;
    show_retrievearguments: '0' | '1';
    show_arg_datefomtom: '0' | '1';
    helptext_datefomtom: string;
    show_arg_businessco_no: '0' | '1';
    show_arg_stockplace_id: '0' | '1';
    show_arg_searchtext: '0' | '1';
    helptext_searchtext: string;
    show_arg_pricelist_id: '0' | '1';
    show_arg_supplier_no: '0' | '1';
    show_arg_project_keyno: '0' | '1';
    show_arg_cust_no: '0' | '1';
    show_arg_labour_no: '0' | '1';
    show_arg_orderstatus_id: '0' | '1';
    show_arg_ordertype_id: '0' | '1';
    show_arg_businesssite_keyno: '0' | '1';
    show_order_order_no: '0' | '1';
    show_collection_name: '0' | '1';
    show_arg_coop_id: '0' | '1';
    show_activestatus_id: '0' | '1';
    h_show_in_menu: string;
    show_in_menu: '0' | '1';
    p2_webpage_keyno: string | number;
}

export interface P2ExportProcWebpageItem {
    item_id: string | number;
    item_name: string;
}
export interface P2ExportProcListItem { item_id: string | number; item_name: string; }

export interface GridExportArgParams {
    argtype: string;
    argvalue: string;
    p2_exportproc_keyno: string;
}

export interface GridExportArgGet extends Partial<P2ExportProcGet> {
    view_id?: string;
    p2_datatask_keyno_2?: string | number;
    p2_datatask_keyno_3?: string | number;
    businessco_no?: string;
    stockplace_id?: string;
    orderstatus_id?: string;
    ordertype_id?: string;
    date_fom?: string;
    date_tom?: string;
    dateselector_index?: string;
    date_fomtom?: string;
    searchtext?: string;
    supplier_no?: string;
    supplier_name?: string;
    pricelist_id?: string;
    project_keyno?: string;
    project_name?: string;
    cust_no?: string;
    cust_name?: string;
    labour_no?: string;
    labour_name?: string;
    businesssite_keyno?: string;
    order_internal_no?: string;
    order_order_no_and_cust_name?: string;
    collection_keyno?: string;
    collection_name?: string;
    coop_id?: string;
    activestatus_id?: string;
}

export interface GridExportPriceListItem {
    pricelist_id: string;
    pricelist_name: string;
}
